import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { AvatarSize } from '@libs/shared/ui/avatar/avatar.component';

@Component({
  selector: 'app-sprint-logo-avatar',
  standalone: true,
  imports: [CommonModule, MatIconModule],
  template: `
    <div
      class="flex-0 ring-bg-default flex items-center justify-center rounded-full bg-gray-100 text-gray-500 ring ring-offset-1 ring-offset-transparent"
      [ngClass]="{
        'h-8 w-8': avatarSize === 'sm',
        'h-12 w-12': avatarSize === 'md',
        'h-16 w-16': avatarSize === 'lg',
        'h-24 w-24': avatarSize === 'xl'
      }">
      <img
        [ngClass]="{
          'h-8 w-8': avatarSize === 'sm',
          'h-12 w-12': avatarSize === 'md',
          'h-16 w-16': avatarSize === 'lg',
          'h-24 w-24': avatarSize === 'xl'
        }"
        [src]="imagePath" />
    </div>
  `,
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SprintLogoAvatarComponent {
  @Input() avatarSize: AvatarSize = 'sm';
  imagePath = 'assets/images/logo/logo.svg';
}
